<template>
    <v-main>
        <top-bar
            :height="'48vh'"
            title="IC卡"
            addTitle="添加"
            :loading="loading"
            :isShowRefresh="true"
            @refresh="refresh"
            @add="add"
            @search="search"
        />
        <v-container fluid class="mt-n6">
			<div class="search">
			    <div class="mobile">
			        <el-input
			            type="text"
			            v-model="form.no"
			            clearable
			            style="width: 95%"
			            placeholder="卡号"
			        ></el-input>
			    </div>
				<div class="mobile" v-if="role === 0">
					<select-platform
						@choose="choosePlatformId"
					    :selectPlatform="form.platform_id"
					    :width="'98%'"
					/>
				</div>
			    <div class="btn-search">
			        <el-button
			            type="primary"
			            icon="el-icon-search"
			            @click="searchBtn()"
			            size="medium"
			        ></el-button>
			    </div>
			</div>
            <v-data-table
                fixed-header
                :headers="headers"
                :items="icList"
                :loading="loading"
                loading-text="数据加载中..."
                disable-sort
                :server-items-length="totalCount"
                :options.sync="options"
                :footer-props="footerProps"
                no-data-text="未查询到数据"
                :dark="theme.tableDark"
            >	
				<template v-slot:item.no="{ item }">
					<el-link
						type="primary"
						icon="el-icon-view el-icon--right"
						class="ml-3"
						@click="showDetails(item)"
					>
						{{ item.no }}
					</el-link>
				</template>
				<template v-slot:item.stations="{ item }">
				    <div class="more">
				        <el-link
				            :underline="false"
				            v-for="(id, index) in item.stations"
				            :key="index"
				            style="font-size:1vw;padding: 0.2rem 0.5rem"
				        >
				            {{ showStationName(id) }}
				        </el-link>
				    </div>
				</template>
			</v-data-table>
        </v-container>
        <v-dialog
            scrollable
            v-model="isICForm"
            :persistent="true"
            width="40em"
            overlay-color="#262626"
        >
            <ICForm v-if="isSite" 
					@cancel="cancel" 
					@refresh="refresh" 
					:isAdd="isAdd" 
					:isEdit="isEdit" 
					:icData="icData"/>
        </v-dialog>
    </v-main>
</template>
<script>
import util from "@/util";
import TopBar from "@/components/TopBar";
import ICForm from "@/components/Form/ICForm";
import SelectPlatform from "@/components/SelectPlatform";
import store from "@/store";
import { mapState } from "vuex";
import Public from "@/public"
export default {
    name: "Ic",
    components: {
        TopBar,
        ICForm,
		SelectPlatform
    },
    data() {
        return {
            loading: true,
			isICForm: false,
            isAdd: false,
            isEdit: false,
			isSite: false,
            icList: [],
			icData: {},
            headers: [
                { text: "卡号", value: "no" },
				{ text: "站点", value: "stations" },
            ],
            totalCount: 1000,
            footerProps: {
                itemsPerPageText: "每页显示数目",
                itemsPerPageOptions: [5, 10, 15],
                showCurrentPage: true,
                showFirstLastPage: true,
            },
            options: {}, //外部控制分页
			form: {
			    no: null,
				platform_id: null,
			},
        };
    },
    watch: {
        // 刷新参数
        options: {
            handler(val) {
                this.getICList();
            },
            deep: true,
        },
		icData() {
		    this.isSite = false;
		    this.$nextTick(() => {
		        this.isSite = true;
		    });
		},
    },
	mounted() {
		if(this.role !== 0) {
			this.form.platform_id = this.platform_id
		}
		this.getSite();
	},
    computed: {
        ...mapState(["theme","siteInfo","role","platform_id"]),
    },
    methods: {
        async refresh() {
			await this.getSite();
            await this.getICList();
        },
		/*选择平台*/
		choosePlatformId(platformId) {
		    this.form.platform_id = platformId;
		    this.getICList();
		},
		/*搜索按钮*/
		searchBtn() {
		    this.getICList();
		},
        async getICList() {
			this.loading = true;
			const { page, itemsPerPage } = this.options;
			let params = {
			    postData: {
					from: (page - 1) * itemsPerPage,
					limit: itemsPerPage,
					no: Public.removeSpace(this.form.no),
					platform_id: this.form.platform_id
				},
			    callbackOk:(data)=> {
			    	console.log(data)
			    	this.icList = data;
			    },
				callback:()=> {
					this.loading = false;
				}
			};
            await store.dispatch("getICCardList", params);
        },
        async getSite() {
			let postData = {
			    from: 0,
			    limit: 10000,
			};
			await store.dispatch("getSite", postData);
		},
		add() {
            this.isICForm = true;
			this.isAdd = true;
			this.isEdit = false;
			this.icData = {};
        },
        cancel() {
            this.isICForm = false;
        },
        search() {},
		/*打开互联互通详细信息*/
		showDetails(item) {
			this.isICForm = true;
		    this.isAdd = false;
		    this.isEdit = true;
		    this.icData = item;
		},
		/*显示站点名称*/
		showStationName(station_id) {
		    let idArr = [];
		    let text = null;
		    for (let i = 0; i < this.siteInfo.length; i++) {
		        if (station_id == this.siteInfo[i].id) {
		            text = this.siteInfo[i].name;
		        }
		        idArr.push(this.siteInfo[i].id);
		    }
		    if (!idArr.includes(station_id)) {
		        text = station_id;
		    }
		    return text;
		},
    },
};
</script>
<style scoped>
.search {
    width: 100%;
    min-height: 3.5rem;
    display: flex;
    flex-direction: row;
	flex-wrap: wrap;
    border-radius: 0.8rem;
    background-color: #eff1f7;
}
.mobile {
    width: 15rem;
    height: 3.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
}
.btn-search {
    width: 4rem;
    height: 3.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
}	
.more {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: center;
	max-width: 25rem;
	height: 3.5em;
	/* background-color: red; */
	overflow-x: hidden;
	overflow-y: auto;
}
</style>
